import { Controller } from "@hotwired/stimulus"

// Two-step video extension flow: reveal prompt form → fetch LLM suggestion →
// user edits → submit extension with custom prompt.
export default class extends Controller {
  static targets = ["formPanel", "promptInput", "promptHidden"]
  static values = { suggestUrl: String, sceneId: String }

  toggleForm() {
    const panel = this.formPanelTarget
    const isHidden = panel.classList.contains("hidden")
    panel.classList.toggle("hidden")

    if (isHidden) this.fetchSuggestion()
  }

  async fetchSuggestion() {
    this.promptInputTarget.value = ""
    this.promptInputTarget.placeholder = "Generating suggestion..."
    this.promptInputTarget.disabled = true

    try {
      const response = await fetch(this.suggestUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ scene_id: this.sceneIdValue })
      })
      const data = await response.json()
      this.promptInputTarget.value = data.prompt || "Continue the scene naturally."
    } catch {
      this.promptInputTarget.value = "Continue the scene naturally with the same style and motion."
    } finally {
      this.promptInputTarget.disabled = false
      this.promptInputTarget.placeholder = "Describe what should happen next..."
      this.promptInputTarget.focus()
    }
  }

  submitExtension() {
    this.promptHiddenTarget.value = this.promptInputTarget.value
  }
}
